module.exports = __webpack_public_path__ + "img/logo-dark-bg.45ec7ff3.svg";